import { buryPoint } from '@/Common/plugins/buried-point';

export default {
  inBatchConfig() {
    buryPoint.event({
      action: '设备批量配置-使用模块',
      eventCategory: '设备批量配置'
    });
  },
  inActiveDeviceTab(index) {
    const result = {
      0: '有设备',
      1: '空白页'
    };
    buryPoint.event({
      action: '设备批量配置-进入激活设备tab',
      eventCategory: '设备批量配置',
      eventLabel: result[index]
    });
  },
  inAddIpChannelTab(index) {
    const result = {
      0: '有设备',
      1: '空白页'
    };
    buryPoint.event({
      action: '设备批量配置-进入添加IP通道页',
      eventCategory: '设备批量配置',
      eventLabel: result[index]
    });
  },
  loginEventAndFrequency() {
    buryPoint.event({
      action: '登录已激活设备-登录',
      eventCategory: '设备批量配置'
    });
  },
  showPasswordFrequency(type) {
    const result = {
      1: '激活设备tab',
      2: '添加IP通道tab',
      3: '配置参数tab'
    };
    buryPoint.event({
      action: '登录已激活设备-进入弹窗',
      eventCategory: '登录已激活设备',
      eventLabel: result[type]
    });
  },
  loginAndUseMultiPassword() {
    buryPoint.event({
      action: '登录已激活设备-复用同一密码登录其他设备',
      eventCategory: '登录已激活设备'
    });
  },
  loginAndFailed(type) {
    const result = {
      1: '密码错误',
      2: '设备已被锁定',
      3: '设备网络参数错误'
    };
    buryPoint.event({
      action: '登录已激活设备-登录失败',
      eventCategory: '登录已激活设备',
      eventLabel: result[type]
    });
  },
  addIpChannel() {
    buryPoint.event({
      action: '添加IP通道-使用功能',
      eventCategory: '添加IP通道'
    });
  },
  addIpChannelFail() {
    buryPoint.event({
      action: '添加IP通道-添加失败',
      eventCategory: '添加IP通道'
    });
  },
  deleteIpChannel() {
    buryPoint.event({
      action: '删除通道-使用功能',
      eventCategory: '添加IP通道'
    });
  },
  replaceIpChannel() {
    buryPoint.event({
      action: '替换设备-使用功能',
      eventCategory: '添加IP通道'
    });
  },

  configureParameter(index) {
    const result = {
      1: '有设备',
      2: '空白页'
    };
    buryPoint.event({
      action: '设备批量配置-进入配置参数tab',
      eventCategory: '设备批量配置',
      eventLabel: result[index]
    });
  },
  clickCompleteBatchConfig() {
    buryPoint.event({
      action: '设备批量配置-完成设备批量配置',
      eventCategory: '设备批量配置'
    });
  },
  clickCompleteBatchConfigCancel() {
    buryPoint.event({
      action: '设备批量配置-完成-取消',
      eventCategory: '设备批量配置'
    });
  },
  saveDataTemplate() {
    buryPoint.event({
      action: '设备批量配置-远程配置页-保存数据模板',
      eventCategory: '设备批量配置-远程配置页'
    });
  },
  configParametersByTemplate() {
    buryPoint.event({
      action: '按模板配置参数-进入弹窗',
      eventCategory: '按模板配置参数'
    });
  },
  sendConfigParameter() {
    buryPoint.event({
      action: '按模板配置参数-下发配置参数',
      eventCategory: '按模板配置参数'
    });
  },
  //记录从点击下发配置参数按钮开始到出现下发结果的所用时长及设备总数
  sendConfigParameterTime(time, number) {
    buryPoint.event({
      action: '按模板配置参数-下发耗时',
      eventCategory: '按模板配置参数',
      eventLabel: `时长${time}秒, 下发的设备总数${number}个`
    });
  },
  //统计结果出现频次
  sendConfigParameterReason() {
    buryPoint.event({
      action: '按模板配置参数-下发结果',
      eventCategory: '按模板配置参数'
    });
  },
  //记录下发配置参数结果弹窗中，总共下发的设备数与下发失败的设备数，以统计平均下发失败率
  sendConfigParameterRatio(all, fail, partialSuccess) {
    buryPoint.event({
      action: '按模板配置参数-下发结果数目',
      eventCategory: '按模板配置参数',
      eventLabel: `总设备数：${all}, 失败数：${fail}，部分成功数：${partialSuccess}`
    });
  },
  deviceRename() {
    buryPoint.event({
      action: '设备重命名-使用功能',
      eventCategory: '设备重命名'
    });
  },
  newDataTemplate() {
    buryPoint.event({
      action: '新建数据模板-使用功能',
      eventCategory: '新建数据模板'
    });
  },
  deleteDataTemplate() {
    buryPoint.event({
      action: '删除数据模板-使用功能',
      eventCategory: '删除数据模板'
    });
  },
  clickActiveAndAssignIp() {
    buryPoint.event({
      action: '激活设备并分配地址-激活',
      eventCategory: '激活设备并分配地址'
    });
  },
  ActiveAndAssignIpResult() {
    buryPoint.event({
      action: '激活设备并分配地址-激活结果',
      eventCategory: '激活设备并分配地址'
    });
  },
  enterRemoteConfig() {
    buryPoint.event({
      action: '设备批量配置-远程配置页-使用功能',
      eventCategory: '设备批量配置-远程配置页'
    });
  },
  AutoAssignDeviceIP(where) {
    const op = {
      1: '设备批量配置-激活设备',
      2: '设备批量配置-修改设备信息',
      3: '设备添加-激活设备',
      4: '设备添加-修改设备信息'
    };
    buryPoint.event({
      action: '设备批量配置-自动分配IP-使用功能',
      eventCategory: '设备批量配置',
      eventLabel: op[where]
    });
  },
  batchRemoteConfigTipsClick(type) {
    const op = {
      1: '激活激活',
      2: '添加IP通道',
      3: '配置参数'
    };
    buryPoint.event({
      action: '设备批量配置引导提示-查看提示',
      eventCategory: '设备批量配置引导提示',
      eventLabel: op[type]
    });
  },
  batchRemoteConfigView() {
    buryPoint.event({
      action: '远程批量配置-使用模块',
      eventCategory: '远程批量配置'
    });
  },
  activeDeviceDialogEnter() {
    buryPoint.event({
      action: '激活设备并分配地址-进入弹窗',
      eventCategory: '激活设备并分配地址'
    });
  },
  activeDeviceDialogAllDevices(num) {
    buryPoint.event({
      action: '激活设备并分配地址-激活总设备数',
      eventCategory: '激活设备并分配地址',
      eventLabel: num,
      value: num
    });
  },
  activeDeviceDialogFailedDecices(num) {
    buryPoint.event({
      action: '激活设备并分配地址-激活失败个数',
      eventCategory: '激活设备并分配地址',
      eventLabel: num
    });
  },
  activeDeviceDialogFailed(reason) {
    buryPoint.event({
      action: '激活设备并分配地址-激活失败',
      eventCategory: '激活设备并分配地址',
      eventLabel: reason
    });
  },
  singleBatchConfigDialog() {
    buryPoint.event({
      action: '处理单个异常事件-打开处理弹窗',
      eventCategory: '处理单个异常事件'
    });
  },
  singleBatchConfigDialogConfirm() {
    buryPoint.event({
      action: '处理单个异常事件-完成处理',
      eventCategory: '处理单个异常事件'
    });
  },
  eventStatusFiltering(num) {
    const op = {
      1: '已修复',
      2: '待检查',
      3: '错误报警',
      0: '未处理',
      5: '全部'
    };
    buryPoint.event({
      action: '事件状态筛选-使用功能',
      eventCategory: '事件状态筛选',
      eventLabel: op[num]
    });
  },
  batchConfigDialog() {
    buryPoint.event({
      action: '批量处理异常事件-进入批量处理',
      eventCategory: '批量处理异常事件'
    });
  },
  batchConfigDialogConfirm() {
    buryPoint.event({
      action: '批量处理异常事件-完成批量处理',
      eventCategory: '批量处理异常事件'
    });
  },
  viewDeviceHealthMonitoring() {
    buryPoint.event({
      action: '查看设备健康监测-按钮点击',
      eventCategory: '查看设备健康监测'
    });
  },
  IPAddressRangeSet(type) {
    const event = {
      1: 'IP设置',
      2: '完成'
    };
    buryPoint.event({
      action: `IP地址段范围设置-${event[type]}`,
      eventCategory: 'IP地址段范围设置 '
    });
  },
  autoConfigNVR(type) {
    const event = {
      1: '按钮点击',
      2: '进度弹窗'
    };
    buryPoint.event({
      action: `自动配置NVR设备-${event[type]}`,
      eventCategory: '自动配置NVR设备'
    });
  }
};
